import React, { useState } from 'react';
import {
  Alert, Box, Button, IconButton, InputAdornment, Paper, TextField, Typography
} from '@mui/material';
import {
  ArrowBack, Inventory2Outlined, KeyOutlined, LockOutlined,
  LockResetOutlined, Visibility, VisibilityOff
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { apiFetch } from '../services/api';

export default function ResetHasla(){
  const location=useLocation();
  const [login,setLogin]=useState(location.state?.login||location.state?.email||'');
  const [kod,setKod]=useState('');
  const [haslo,setHaslo]=useState('');
  const [powtorz,setPowtorz]=useState('');
  const [blad,setBlad]=useState('');
  const [sukces,setSukces]=useState(false);
  const [wysylanie,setWysylanie]=useState(false);
  const [pokazHaslo,setPokazHaslo]=useState(false);
  const [pokazPowtorz,setPokazPowtorz]=useState(false);

  const submit=async e=>{
    e.preventDefault();setBlad('');
    if(haslo.length<8 || !/[A-ZĄĆĘŁŃÓŚŹŻ]/.test(haslo) || !/[^A-Za-z0-9ĄĆĘŁŃÓŚŹŻąćęłńóśźż]/.test(haslo)){setBlad('Hasło musi mieć co najmniej 8 znaków, co najmniej jedną wielką literę i jeden znak specjalny.');return;}
    if(haslo!==powtorz){setBlad('Hasła nie są takie same.');return;}
    setWysylanie(true);
    try{
      await apiFetch('/haslo/reset',{
        method:'POST',
        body:JSON.stringify({login,kod,haslo})
      });
      setSukces(true);
    }catch(e){
      setBlad(e.message);
    }finally{
      setWysylanie(false);
    }
  };

  return (
    <Box sx={{minHeight:'100vh',bgcolor:'#f4f7fb',display:'grid',placeItems:'center',p:{xs:2,md:4}}}>
      <Paper elevation={0} sx={{
        width:'100%',maxWidth:980,minHeight:{md:560},display:'grid',
        gridTemplateColumns:{xs:'1fr',md:'0.92fr 1.08fr'},overflow:'hidden',borderRadius:4,
        border:'1px solid #e1e8f2',boxShadow:'0 18px 55px rgba(18,46,84,.10)'
      }}>
        <Box sx={{
          display:{xs:'none',md:'flex'},flexDirection:'column',justifyContent:'space-between',
          p:5,color:'#fff',
          background:'linear-gradient(145deg, #173d73 0%, #245fae 58%, #2f80ed 100%)'
        }}>
          <Box>
            <Box sx={{
              width:58,height:58,borderRadius:3,display:'grid',placeItems:'center',
              bgcolor:'rgba(255,255,255,.14)',border:'1px solid rgba(255,255,255,.22)',mb:3
            }}>
              <Inventory2Outlined sx={{fontSize:32}}/>
            </Box>
            <Typography variant="h4" fontWeight={900} sx={{lineHeight:1.15,mb:1.5}}>
              Ewidencja środków trwałych
            </Typography>
            <Typography sx={{color:'rgba(255,255,255,.78)',maxWidth:330,lineHeight:1.65}}>
              Ustaw nowe hasło i wróć do pracy w systemie.
            </Typography>
          </Box>
          <Typography variant="caption" sx={{color:'rgba(255,255,255,.60)'}}>
            System ewidencji środków trwałych
          </Typography>
        </Box>

        <Box sx={{
          p:{xs:3,sm:5,md:6},display:'flex',flexDirection:'column',justifyContent:'center',bgcolor:'#fff'
        }}>
          <Box sx={{display:{xs:'flex',md:'none'},alignItems:'center',gap:1.2,mb:4}}>
            <Box sx={{width:42,height:42,borderRadius:2.2,display:'grid',placeItems:'center',bgcolor:'#eaf2ff',color:'#2364d8'}}>
              <Inventory2Outlined/>
            </Box>
            <Typography fontWeight={900}>Ewidencja środków trwałych</Typography>
          </Box>

          <Box sx={{width:48,height:48,borderRadius:2.5,bgcolor:'#eaf2ff',color:'#2364d8',display:'grid',placeItems:'center',mb:2.5}}>
            <LockResetOutlined/>
          </Box>

          <Typography variant="h4" fontWeight={900} sx={{color:'#1c2b3a',mb:.7}}>
            Ustaw nowe hasło
          </Typography>
          <Typography color="text.secondary" sx={{mb:3.5}}>
            Wprowadź kod oraz nowe hasło do konta.
          </Typography>

          {blad&&<Alert severity="error" sx={{mb:2.5,borderRadius:2}}>{blad}</Alert>}

          {!sukces ? (
            <Box component="form" onSubmit={submit} sx={{display:'grid',gap:2}}>
              <TextField
                label="Login lub e-mail"
                value={login}
                onChange={e=>setLogin(e.target.value)}
                required
              />

              <TextField
                label="Kod z e-maila"
                value={kod}
                onChange={e=>setKod(e.target.value.replace(/\D/g,'').slice(0,6))}
                inputProps={{inputMode:'numeric',maxLength:6}}
                required
                InputProps={{
                  startAdornment:<InputAdornment position="start"><KeyOutlined sx={{color:'#7b8794'}}/></InputAdornment>
                }}
              />

              <TextField
                type={pokazHaslo?'text':'password'}
                label="Nowe hasło"
                value={haslo}
                onChange={e=>setHaslo(e.target.value)}
                helperText="Min. 8 znaków, 1 wielka litera i 1 znak specjalny"
                required
                InputProps={{
                  startAdornment:<InputAdornment position="start"><LockOutlined sx={{color:'#7b8794'}}/></InputAdornment>,
                  endAdornment:<InputAdornment position="end">
                    <IconButton onClick={()=>setPokazHaslo(v=>!v)} edge="end" aria-label={pokazHaslo?'Ukryj hasło':'Pokaż hasło'}>
                      {pokazHaslo?<VisibilityOff/>:<Visibility/>}
                    </IconButton>
                  </InputAdornment>
                }}
              />

              <TextField
                type={pokazPowtorz?'text':'password'}
                label="Powtórz nowe hasło"
                value={powtorz}
                onChange={e=>setPowtorz(e.target.value)}
                required
                InputProps={{
                  startAdornment:<InputAdornment position="start"><LockOutlined sx={{color:'#7b8794'}}/></InputAdornment>,
                  endAdornment:<InputAdornment position="end">
                    <IconButton onClick={()=>setPokazPowtorz(v=>!v)} edge="end" aria-label={pokazPowtorz?'Ukryj hasło':'Pokaż hasło'}>
                      {pokazPowtorz?<VisibilityOff/>:<Visibility/>}
                    </IconButton>
                  </InputAdornment>
                }}
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={wysylanie}
                sx={{
                  mt:.5,minHeight:48,borderRadius:2,textTransform:'none',fontWeight:850,fontSize:15,
                  boxShadow:'none',bgcolor:'#2364d8','&:hover':{bgcolor:'#1d56ba',boxShadow:'none'}
                }}
              >
                {wysylanie?'Zapisywanie...':'Zmień hasło'}
              </Button>
            </Box>
          ) : (
            <Box>
              <Alert severity="success" sx={{mb:2,borderRadius:2}}>
                Hasło zostało zmienione.
              </Alert>
              <Button
                component={Link}
                to="/logowanie"
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  minHeight:48,borderRadius:2,textTransform:'none',fontWeight:850,
                  boxShadow:'none',bgcolor:'#2364d8','&:hover':{bgcolor:'#1d56ba',boxShadow:'none'}
                }}
              >
                Przejdź do logowania
              </Button>
            </Box>
          )}

          {!sukces&&(
            <Box sx={{display:'flex',justifyContent:'space-between',gap:1,flexWrap:'wrap',mt:2.2}}>
              <Button
                component={Link}
                to="/zapomniane-haslo"
                startIcon={<ArrowBack/>}
                sx={{textTransform:'none',fontWeight:750}}
              >
                Wyślij nowy kod
              </Button>
              <Button
                component={Link}
                to="/logowanie"
                sx={{textTransform:'none',fontWeight:750}}
              >
                Wróć do logowania
              </Button>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
